import { CSSProperties } from "@remirror/theme";
import { MainContainer } from "./styles";

interface propsInterface {
  margin?: number;
  children: any;
  style?: CSSProperties;
  className?: string;
}

const Component = ({ children, ...rest }: propsInterface) => {
  return <MainContainer {...rest}>{children}</MainContainer>;
};

export default Component;
